module.exports = __webpack_public_path__ + "img/arrow-down.28393f3c.svg";